import { render, staticRenderFns } from "./TributeDeadlineChip.vue?vue&type=template&id=47891bf0&scoped=true"
import script from "./TributeDeadlineChip.vue?vue&type=script&lang=js"
export * from "./TributeDeadlineChip.vue?vue&type=script&lang=js"
import style0 from "./TributeDeadlineChip.vue?vue&type=style&index=0&id=47891bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47891bf0",
  null
  
)

export default component.exports